export default __webpack_public_path__ + "static/pic04-11c92e7a68427bd4acce2d3683aedfaa.jpg";